import { ReduceStore } from 'flux/utils';
import Dispatcher from './Dispatcher';
import ActionTypes from './ActionTypes';
import TimelessThemeManager from './TimelessThemeManager';
import ThemeStatusTypes from "./ThemeStatusTypes";
import ActivityManager from "./ActivityManager";

class TimelessThemeStore extends ReduceStore {
  constructor() {
    super(Dispatcher);
  }

  getInitialState() {
    return null;
  }

  reduce(state, action) {
    switch (action.actionType) {
      case ActionTypes.TIMELESS_THEME_STORE_FIND:
        TimelessThemeManager.find(action.categoryId, action.themeId);
        return this.getInitialState();

      case ActionTypes.TIMELESS_THEME_STORE_FIND_COMPLETE:
        ActivityManager.saveActivity({
          theme_id: action.theme.id,
          category_id: action.theme.categoryId,
          event_type: ThemeStatusTypes.THEME_STATUS_STARTED,
        });
        return action.theme;

      case ActionTypes.TIMELESS_THEME_STORE_MARK_AS_COMPLETED:
        ActivityManager.saveActivity({
          theme_id: action.themeId,
          category_id: action.categoryId,
          event_type: ThemeStatusTypes.THEME_STATUS_COMPLETED,
        });
        return state;

      case ActionTypes.ACTIVITY_SAVED:
        return {
          ...state,
          status: action.activity.event_type,
          statusDate: action.activity.updated_at,
        };

      default:
        return state;
    }
  }
}

export default new TimelessThemeStore();
